import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { GridApi, Module, ModuleRegistry } from "@ag-grid-community/core";
import { ClipboardModule } from "@ag-grid-enterprise/clipboard";
import { ColumnsToolPanelModule } from "@ag-grid-enterprise/column-tool-panel";
import { FiltersToolPanelModule } from "@ag-grid-enterprise/filter-tool-panel";
import { MultiFilterModule } from "@ag-grid-enterprise/multi-filter";
import { ServerSideRowModelModule } from "@ag-grid-enterprise/server-side-row-model";
import { SetFilterModule } from "@ag-grid-enterprise/set-filter";
import { SideBarModule } from "@ag-grid-enterprise/side-bar";
import { RangeSelectionModule } from "@ag-grid-enterprise/range-selection";
import { StatusBarModule } from "@ag-grid-enterprise/status-bar";
import { MasterDetailModule } from "@ag-grid-enterprise/master-detail";
import { DatePickerModel } from "src/app/components/date-picker-dialog/date-picker.model";
import { Subject } from "rxjs";

ModuleRegistry.registerModules([
  ServerSideRowModelModule,
  MultiFilterModule,
  SetFilterModule,
  SideBarModule,
  FiltersToolPanelModule,
  ColumnsToolPanelModule,
  ClipboardModule,
  RangeSelectionModule,
  StatusBarModule,
  MasterDetailModule,
]);

@Component({
  selector: "app-grid-wrapper",
  templateUrl: "./grid-wrapper.component.html",
  styleUrls: ["./grid-wrapper.component.scss"],
})
export class GridWrapperComponent implements OnInit,OnDestroy {
  @Input() gridOptions;
  @Input() columnDefs;
  @Input() page;
  @Input() bulkType;
  @Input() showActions = true;
  @Input() actions;
  @Input() defaultColDef;
  @Input() masterDetail;
  @Input() detailCellRendererParams;
  @Input() detailRowAutoHeight;
  modules: Module[] = [ServerSideRowModelModule];
  @Output() sideBar = new EventEmitter<any>();
  @Output()groupBySalesTrendList: EventEmitter<any> = new EventEmitter();
  @Output() dateFilterOutput: EventEmitter<DatePickerModel> = new EventEmitter();
  @Output() accountFilterType: EventEmitter<DatePickerModel> = new EventEmitter();
  @Output() multipleDateFilter: EventEmitter<any>= new EventEmitter();
  @Output()groupByList: EventEmitter<any> = new EventEmitter();
  @Output()groupBySkuList: EventEmitter<any> = new EventEmitter();
  @Output() viewByPlList:EventEmitter<any> = new EventEmitter();
  @Output()dateChange: EventEmitter<any> = new EventEmitter();
  @Output() selectedDateRange: EventEmitter<any>= new EventEmitter();
  @Input() datePickerLabel;
  @Output()groupBySettlementList: EventEmitter<any> = new EventEmitter();
  @Input() defaultDateFilter: DatePickerModel;
  @Input() hideSearch: boolean = false;
  @Input() overlayNoRowsTemplate;
  gridApi: GridApi;
  rowModelType;
  rowData: [];
  @Output() selectedWarehosue:EventEmitter<any>=new EventEmitter();
  @Output()groupByColumns: EventEmitter<any> = new EventEmitter();
  private destroy$ = new Subject<void>();
  constructor() {}
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {}
  onlogisticSideBar(event){
    this.sideBar.emit(event)
  }

  setDateFilter(e: DatePickerModel) {
    this.dateFilterOutput.emit(e);
  }
  setAccountFilter(e){
    this.accountFilterType.emit(e);
  }

  groupByListFilter(e){
    this.groupByList.emit(e);
  }

  setDateByDefault(e){
    this.dateChange.emit(e);
  }

  groupBySettlementListFilter(event){
    this.groupBySettlementList.emit(event)

  }

  setmultipleDateFilter(event){
    this.multipleDateFilter.emit({event});
  }

  groupSkuList($event){
  this.groupBySkuList.emit($event);
  }

  groupByPlFilter($event){
    this.viewByPlList.emit($event)
  }

  setDateRange($event){
    this.selectedDateRange.emit($event);
  }
  groupBysalesFilter(event){
    this.groupBySalesTrendList.emit(event);
   }
   
   groupByDefaultList($event){
    this.groupByColumns.emit($event);
   }

   setWarehouse(event){
    this.selectedWarehosue.emit(event);
   }




}
